import { SearchLg } from "@untitledui/icons";
import { type To } from "react-router";

import { LoadingIndicator } from "@/components/loading-indicator/loading-indicator";
import { PageHeader } from "@/components/page-header/page-header";
import { StatusMessage } from "@/components/status-messages/status-message";
import { SidebarNavigation } from "@/features/navigation/sidebar-navigation";
import { cx } from "@/utils/cx";
export interface MainLayoutProps {
	backButtonPath?: To;
	children: React.ReactNode;
	className?: string;
	description?: string;
	emptyComponent?: React.ReactNode;
	errorComponent?: React.ReactNode;
	headerButtons?: React.ReactNode;
	headerDropdown?: React.ReactNode;
	includeBackButton?: boolean;
	isEmpty?: boolean;
	isError?: boolean;
	isLoading?: boolean;
	loadingComponent?: React.ReactNode;
	title: React.ReactNode | string;
}

export const MainLayout = ({
	backButtonPath,
	children,
	className,
	description,
	emptyComponent,
	errorComponent,
	headerButtons,
	headerDropdown,
	includeBackButton = false,
	isEmpty = false,
	isError = false,
	isLoading = false,
	loadingComponent,
	title,
}: MainLayoutProps) => {
	// Loading Component for the main layout
	const mainLayoutLoadingComponent = loadingComponent ? (
		loadingComponent
	) : (
		<LoadingIndicator centered="fixed" size="md" />
	);
	// Empty Component for the main layout
	const mainLayoutEmptyComponent = emptyComponent ? (
		emptyComponent
	) : (
		<StatusMessage
			icon={<SearchLg />}
			includeCallToAction
			title="No Data Found"
		/>
	);
	// Error Component for the main layout
	const mainLayoutErrorComponent = errorComponent ? (
		errorComponent
	) : (
		<StatusMessage />
	);

	return (
		<div className={cx("flex flex-col lg:flex-row", className)}>
			<SidebarNavigation />

			<main className="scrollbar-hide flex h-full w-full max-w-full flex-col overflow-auto bg-primary lg:h-screen lg:rounded-l-4xl lg:rounded-b-none">
				{!isError && (
					<PageHeader
						backButtonPath={backButtonPath}
						buttons={headerButtons}
						description={description}
						dropdown={headerDropdown}
						includeBackButton={includeBackButton}
						isLoading={isLoading}
						title={title}
					/>
				)}

				{isLoading && mainLayoutLoadingComponent}

				{isEmpty && mainLayoutEmptyComponent}

				{isError && mainLayoutErrorComponent}

				{!isLoading && !isEmpty && !isError && (
					<div className="flex max-h-full w-full overflow-hidden">
						<div className="relative scrollbar-hide flex max-h-(--page-content-height) w-full flex-col overflow-y-auto px-6 pt-6 lg:px-12 lg:pt-8">
							{children}
						</div>
					</div>
				)}
			</main>
		</div>
	);
};
